import React from "react";
import { useSelector } from "react-redux";

const AdminProtected = ({ children }) => {
  const user = useSelector((state) => state.auth.user);
  console.log('user');
  if (
    (user &&
      user?.user &&
      user?.statusType === "SUCCESS" &&
      user.user?.userType?.name === "SUPER_ADMIN") ||
    user?.user?.userType?.name === "ALL_HOME_DESIRE"
  ) {
    return children;
  }

  return null;
};

export default AdminProtected;
